import React, { useState } from 'react';
import { Table, Tag, message, Popconfirm, Button, Tooltip } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import moment from 'moment-timezone';
import { useMutation } from '@apollo/client';
import { DELETE_HOLIDAY } from '../editFranchise/requests';

interface Holiday {
  date: string;
  repeat: boolean;
}

interface HolidayTableProps {
  holidays: Holiday[];
  setHolidays?: (holidays: Holiday[]) => void;
  locationId?: string;
}

const HolidayTable: React.FC<HolidayTableProps> = ({ holidays, setHolidays, locationId }) => {
  const [loadingDate, setLoadingDate] = useState<string | null>(null);

  const [deleteHoliday] = useMutation(DELETE_HOLIDAY);

  const handleDelete = async (date: string) => {
    setLoadingDate(date);
    try {
      await deleteHoliday({
        variables: {
          id: locationId,
          date,
        },
      });

      if (setHolidays) {
        setHolidays(holidays.filter((h) => h.date !== date));
      }

      message.success('Día festivo eliminado correctamente');
    } catch (error) {
      message.error('Ocurrió un error al eliminar el día festivo');
      console.log({ error });
    } finally {
      setLoadingDate(null);
    }
  };

  const columns = [
    {
      title: 'Fecha',
      dataIndex: 'date',
      key: 'date',
      render: (date: Date) => moment(date).format('ll'),
    },
    {
      title: 'Repetir',
      dataIndex: 'repeat',
      key: 'repeat',
      render: (repeat: boolean) =>
        repeat ? <Tag color="green">Sí</Tag> : <Tag color="volcano">No</Tag>,
    },
    {
      title: 'Acciones',
      key: 'action',
      width: '10%',
      render: (_: any, record: Holiday) => (
        <Popconfirm
          title="¿Estás seguro de eliminar este día festivo?"
          onConfirm={() => handleDelete(record.date)}
          okText="Sí"
          cancelText="No"
        >
          <Tooltip title="Eliminar">
            <Button
              loading={loadingDate === record.date}
              danger
              icon={<DeleteOutlined />}
            />
          </Tooltip>
        </Popconfirm>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={holidays.map((h, i) => ({ ...h,
        key: i }))}
      pagination={false}
      size="small"
      bordered
    />
  );
};

export default HolidayTable;
